import React, { useEffect } from 'react';

import { Dates } from 'context/DateProvider/DateProvider';
import useStyles from 'features/Health/components/MonetisationHealthChart/MonetisationHealthChart.styles';
import { initialiseChart } from 'features/Health/components/MonetisationHealthChart/utils/initialiseChart';
import { HealthMetricsHistory } from 'features/Health/containers/MonetisationHealthChartContainer/types/healthMetrics';

type MonetisationHealthChartProps = {
  chartId: string;
  chartData: {
    demand: HealthMetricsHistory[];
    delivery: HealthMetricsHistory[];
  };
  minDateTimeRange: string;
  maxDateTimeRange: string;
  enabledSelect: boolean;
  dateTimeRange?: Dates;
  setDateTimeRange?: React.Dispatch<React.SetStateAction<Dates>>;
};

const MonetisationHealthChart = ({
  chartId,
  chartData,
  minDateTimeRange,
  maxDateTimeRange,
  enabledSelect,
  dateTimeRange,
  setDateTimeRange,
}: MonetisationHealthChartProps) => {
  const classes = useStyles();

  useEffect(() => {
    const root = initialiseChart(
      chartId,
      chartData,
      minDateTimeRange,
      maxDateTimeRange,
      enabledSelect,
      dateTimeRange,
      setDateTimeRange
    );
    return () => {
      root.dispose();
    };
  }, [chartData]);

  return <div data-testid="monetisationHealthChart" id={chartId} className={classes.root} />;
};

export default MonetisationHealthChart;
